import { IGame } from "../types/game";
import GameState from "./game-state";

export class CheckLinkState extends GameState {
  tombe: number;
  anim: number;
  moved: boolean[][] = new Array(36);

  constructor(game: IGame) {
    super(game);
    this.anim = 0;
    this.tombe = 0;
    for (let j = 0; j < 36; j++)
      for (let i = 0; i < 18; i++) this.canvas.moved[j][i] = false;
  }

  enter(): void {
    console.log('[CheckLinkState] Entered');
  }

  update(frameTime: number): void {
    super.update(frameTime);

    if (this.anim === 0) {
      this.fillBlocks();
      this.anim++;
    } else {
      this.tombBlocks();
      this.anim = 0;
    }
  }

  private tombBlocks(): void {
    this.clearMoved();

    let k = 0;
    const moved = this.moveBlocks();
    if (moved) {
      k = 1;
      this.tombee();
      this.tombe++;
    }

    if (k) {
      console.log('[CheckLinkState] Blocks still falling, continuing...');
    } else {
      if (this.tombe) this.playSound();
      console.log('[CheckLinkState] Done, popping state (returns to CheckLineState for recursion)');
      this.game.popState(this);
    }
  }

  private moveBlocks(): boolean {
    let moved = false;

    for (let row = 31; row >= 0; row--) {
      for (let col = 4; col < 14; col++) {
        if (this.canvas.occupied[row][col] && !this.canvas.tmp[row][col]) {
          moved = true;
          this.canvas.blocks[row + 1][col] = this.canvas.blocks[row][col];
          this.canvas.occupied[row + 1][col] = this.canvas.occupied[row][col];
          this.moved[row + 1][col] = true;
          this.canvas.blinded[row + 1][col] = this.canvas.blinded[row][col];
          this.canvas.bflash[row + 1][col] = this.canvas.bflash[row][col];
          this.canvas.dirted[row + 1][col] = 2;
          this.canvas.blocks[row][col] = 0;
          this.canvas.occupied[row][col] = false;
          this.canvas.blinded[row][col] = 0;
          this.canvas.bflash[row][col] = 0;
          this.canvas.dirted[row][col] = 2;
        }
      }
    }
    return moved;
  }

  private playSound(): void {
    let i = -500 + this.tombe * 50;

    if (i > 0) i = 0;
  }

  private tombee(): void {
    /* Some blocks moved, overwrite Canvas::moved */
    for (let j = 0; j < 36; j++) {
      let movementinLineine: boolean = false;
      for (let i = 0; i < 18; i++) {
        if (this.moved[j][i]) {
          movementinLineine = true;
        }
      }
      if (movementinLineine) {
        for (let i = 0; i < 18; i++) {
          this.canvas.moved[j][i] = this.moved[j][i];
        }
      }
    }
  }

  private clearMoved(): void {
    for (let row = 0; row < 36; row++) {
      this.moved[row] = new Array(18);
      for (let col = 0; col < 18; col++) {
        this.moved[row][col] = false;
      }
    }
  }

  private fillBlocks(): void {
    for (let col = 4; col < 14; col++) {
      if (this.canvas.tmp[32][col] !== 1) {
        this.canvas.tmp[32][col] = 1;
      }
    }

    let k = 1;
    while (k) {
      k = 0;
      for (let row = 31; row >= 0; row--) {
        for (let col = 4; col < 14; col++) {
          if (
            this.canvas.blocks[row][col] & 8 &&
            !this.canvas.tmp[row][col] &&
            this.canvas.tmp[row + 1][col]
          ) {
            this.fillBlock(col, row);
            k = 1;
          }
        }
      }
    }
  }

  private fillBlock(col: number, row: number): void {
    // Bounds check: tmp is [0..32][0..17], blocks is [0..35][0..17]
    // Early return if out of bounds (prevents the error "Cannot read properties of undefined")
    if (row < 0 || row >= 33 || col < 0 || col >= 18) return;
    if (!this.canvas.tmp[row] || !this.canvas.blocks[row]) return;
    
    this.canvas.tmp[row][col] = 1;
    // Check bounds before accessing arrays (JavaScript/TypeScript requires explicit bounds checking)
    // Down: row + 1 (tmp is [0..32], blocks is [0..35])
    if (row + 1 < 33 && !(this.canvas.blocks[row][col] & 8) && !this.canvas.tmp[row + 1][col])
      this.fillBlock(col, row + 1);
    // Left: col - 1 (must be >= 0)
    if (col - 1 >= 0 && !(this.canvas.blocks[row][col] & 1) && !this.canvas.tmp[row][col - 1])
      this.fillBlock(col - 1, row);
    // Right: col + 1 (must be < 18)
    if (col + 1 < 18 && !(this.canvas.blocks[row][col] & 4) && !this.canvas.tmp[row][col + 1])
      this.fillBlock(col + 1, row);
    // Up: row - 1 (must be >= 0)
    if (row - 1 >= 0 && !(this.canvas.blocks[row][col] & 2) && !this.canvas.tmp[row - 1][col])
      this.fillBlock(col, row - 1);
  }

  toString(): string {
    return "Check Link";
  }
}
